import template from './coin_pull_report_print.html';
import controller from './coin_pull_report_print.controller';
import './coin_pull_report_print.scss';

let CoinPullReportPrintComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default CoinPullReportPrintComponent;


// WEBPACK FOOTER //
// ./client/app/components/coin_pull_report/print_route_coin/coin_pull_report_print.component.js